// Firestore service for resume operations
import { db } from '../firebase.js';
import { collection, addDoc, query, where, getDocs, deleteDoc, doc, orderBy, Timestamp } from 'firebase/firestore';

const COLLECTION_NAME = 'resumes';

export const saveResumeToCloud = async (userId, resumeData, title = 'Untitled Resume') => {
    try {
        const docRef = await addDoc(collection(db, COLLECTION_NAME), {
            userId,
            title,
            data: JSON.stringify(resumeData),
            createdAt: Timestamp.now(),
            updatedAt: Timestamp.now()
        });
        return docRef.id;
    } catch (error) {
        console.error("Error saving resume: ", error);
        throw error;
    }
};

export const getUserResumes = async (userId) => {
    try {
        const q = query(
            collection(db, COLLECTION_NAME),
            where("userId", "==", userId),
            orderBy("updatedAt", "desc")
        );

        const querySnapshot = await getDocs(q);
        const resumes = [];
        querySnapshot.forEach((doc) => {
            resumes.push({
                id: doc.id,
                ...doc.data(),
                // Convert Timestamp to Date object for easier handling in UI
                createdAt: doc.data().createdAt.toDate(),
                updatedAt: doc.data().updatedAt.toDate()
            });
        });
        return resumes;
    } catch (error) {
        console.error("Error fetching resumes: ", error);
        throw error;
    }
};

export const deleteResumeFromCloud = async (resumeId) => {
    try {
        await deleteDoc(doc(db, COLLECTION_NAME, resumeId));
    } catch (error) {
        console.error("Error deleting resume: ", error);
        throw error;
    }
};
